// extracted by mini-css-extract-plugin
export default {"container":"OQkY2AIZJn9-x_UAlFBLw postfix m-checkbox"};